
import { ListItem, Paper, Avatar, ListItemText, ListItemAvatar, List } from "@material-ui/core";


const Card = ({ title, value, subtitle, icon, primaryColor, secondaryColor, chipPrimaryColor, chipSecondaryColor, textColor, children }) => {
    const cardStyle = {
        maxWidth: "400px",
        padding: '0.5rem',
        background: primaryColor,
        margin: '0.5rem'
    }
    const titleStyle = {
        fontSize: '3.5rem',
        padding: '0.5rem 1rem',
        margin: '0px',
        color: textColor,
        fontWeight: '600'
    }
    const subtitleStyle = {
        margin: '0',
        padding: '1rem',
        color: textColor,
        width: '-webkit-fill-available',
        fontWeight: '100'
    }
    const chipStyle = {
        background: chipPrimaryColor,
        padding: '0.30rem 1rem',
        borderRadius: '38px',
        color: chipSecondaryColor,
        margin: '0.5rem'
    }
    const footerContainerStyle = {
        display: 'flex',
        alignItems: 'center'
    }
    const iconStyle = {
        minWidth: '35px',
        color: secondaryColor
    }

    return (<>
        <Paper style={cardStyle} elevation={3}>
            <List dense={true}>
                <ListItem>
                    <ListItemAvatar style={iconStyle}>
                        {children}
                    </ListItemAvatar>
                    <ListItemText
                        style={{ color: secondaryColor }}
                        primary={title}
                    />
                </ListItem>
            </List>
            <h2 style={titleStyle}>{value}</h2>
            <div style={footerContainerStyle}>
                <p style={subtitleStyle}>{subtitle}</p>
                <div style={chipStyle}>Approved</div>
            </div>

        </Paper>
    </>)
}
export default Card;